import { render, staticRenderFns } from "./issues-info.vue?vue&type=template&id=3650e48c&scoped=true&"
import script from "./issues-info.vue?vue&type=script&lang=js&"
export * from "./issues-info.vue?vue&type=script&lang=js&"
import style0 from "./issues-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./issues-info.vue?vue&type=style&index=1&id=3650e48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650e48c",
  null
  
)

export default component.exports